import {
  AddJdOpsProductT,
  ApplicationActivityT,
  PlantingActivityT,
  SeedCostT,
  TillageWorkT,
} from "../types/addCost";
import axios from "axios";
import { postApi } from "./apis";

const extractApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    if (typeof data === "string" && data.trim()) {
      return data;
    }

    if (data && typeof data === "object") {
      const maybeData = data as {
        message?: unknown;
        error?: unknown;
        title?: unknown;
        detail?: unknown;
        errors?: unknown;
      };

      if (typeof maybeData.message === "string" && maybeData.message.trim()) {
        return maybeData.message;
      }

      if (typeof maybeData.error === "string" && maybeData.error.trim()) {
        return maybeData.error;
      }

      if (typeof maybeData.detail === "string" && maybeData.detail.trim()) {
        return maybeData.detail;
      }

      if (typeof maybeData.title === "string" && maybeData.title.trim()) {
        return maybeData.title;
      }

      if (maybeData.errors && typeof maybeData.errors === "object") {
        const fieldErrors = Object.values(maybeData.errors as Record<string, unknown>)
          .flatMap((value) => (Array.isArray(value) ? value : [value]))
          .filter((value): value is string => typeof value === "string" && value.trim().length > 0);

        if (fieldErrors.length) {
          return fieldErrors.join(" ");
        }
      }
    }

    if (typeof error.message === "string" && error.message.trim()) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Failed to post data: unknown error occurred";
};

export const addJdOpsProduct = async (data: AddJdOpsProductT) => {
  try {
    return await postApi("JdOpsProduct/jdopsproducts/pricing", data);
  } catch (error: unknown) {
    throw new Error(extractApiErrorMessage(error));
  }
};

export const addSeedCost = async (data: SeedCostT) => {
  try {
    return await postApi("SeedCost/seedcosts", data);
  } catch (error: unknown) {
    throw new Error(extractApiErrorMessage(error));
  }
};

export const addApplicationActivity = async (data: ApplicationActivityT) => {
  try {
    return await postApi("ApplicationActivity/applicationactivity/create", data);
  } catch (error: unknown) {
    throw new Error(extractApiErrorMessage(error));
  }
};

export const addPlantingActivity = async (data: PlantingActivityT) => {
  try {
    return await postApi("PlantingActivity/plantingactivity/create", data);
  } catch (error: unknown) {
    throw new Error(extractApiErrorMessage(error));
  }
};

export const addTillageWork = async (data: TillageWorkT) => {
  try {
    return await postApi("TillageWork/Create", data);
  } catch (error: unknown) {
    throw new Error(extractApiErrorMessage(error));
  }
};
